import { useEffect, useState } from "react";
import React from "react";
import FeedbackForm from "./FeedbackForm";
import { teacherFeedback } from "../Services/AllServices"; // Adjust the import path
import { getUserID } from "../Storage/Storage";
import Popup from "./pop_up"; // Import the Popup component

const TeacherFeedback = () => {
  const [userId, setUserId] = useState("");
  const [feedbackDescription, setFeedbackDescription] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false); // State for controlling pop-up visibility
  const [popupMessage, setPopupMessage] = useState(""); // Message for the popup

  useEffect(() => {
    const fetchUserId = async () => {
      const id = await getUserID();
      setUserId(id); // Get user ID from local storage
    };
    fetchUserId();
  }, []); // Added empty dependency array to avoid calling this on every render

  const handleFeedbackSubmit = async () => {
    console.log("User ID:", userId);
    console.log("Feedback Description:", feedbackDescription);

    if (userId && feedbackDescription) {
      const formData = {
        userId,
        description: feedbackDescription,
      };

      const callback = (response) => {
        console.log("Feedback Response:", response);
        setIsPopupVisible(true); // Show the success pop-up
        setPopupMessage("Thank you for your feedback!"); // Set message for the popup
        setFeedbackDescription(""); // Clear the feedback description after successful submission
      };

      await teacherFeedback(formData, callback); // Call the feedback function
    } else {
      console.log("Validation failed. Missing fields.");
      setPopupMessage("Something went wrong. Please try again."); // Set error message for the popup
      setIsPopupVisible(true); // Show the error pop-up
    }
  };

  const handlePopupOk = () => {
    setIsPopupVisible(false); // Hide the popup when "OK" is clicked
    if (popupMessage === "Thank you for your feedback!") {
      window.location.reload(); // Refresh the page only if the feedback was successful
    }
  };

  return (
    <div className="feedback-container">
      <FeedbackForm
        feedbackDescription={feedbackDescription}
        setFeedbackDescription={setFeedbackDescription}
        handleFeedbackSubmit={handleFeedbackSubmit}
        disabled={false}
      />

      {/* Success/Error Pop-up */}
      {isPopupVisible && (
        <Popup message={popupMessage} onConfirm={handlePopupOk} />
      )}
    </div>
  );
};

export default TeacherFeedback;
